<template>
  <div class="card">
    <div class="card-body hm400">
      <h5 class="card-title text-center font-weight-bold">Monitors</h5>
      <div class="table-responsive mt-10">
        <div class="" v-if="loading && !autoLoading">
          <!-- Show the loader when async operation is going on -->
          <div class="loader"></div>
        </div>
        <div class="text-center text-danger fs-16 d-flex align-items-center justify-content-center">
          This is currently in maintenance mode.
        </div>
<!--        <perfect-scrollbar :class="{'scroll-area-modal': (testGroups && testGroups.length > 0) && !loading}" class="" v-else >-->
<!--          <table class="table table-striped single-outage-table">-->
<!--            <thead>-->
<!--            <tr>-->
<!--              <th></th>-->
<!--              <th class='text-left'>test name</th>-->
<!--              <th class="text-center">server ip</th>-->
<!--              <th class="text-center">notes</th>-->
<!--              <th class="text-center">Action</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody v-for="(test, index) in allGroups" :key="index" class="m-0 p-0">-->
<!--            <tr v-if="test.tests.length > 1">-->
<!--              <td>-->
<!--              <span class="ml-1" :class="{ 'details-control shown' : test.showTests, 'details-control' : !test.showTests }" @click="test.showTests= !test.showTests" ></span>-->
<!--              </td>-->
<!--              <td>-->
<!--                {{ test.planName }}-->
<!--              </td>-->
<!--              <td class="text-center make-cursor-pointer" @click="doCopy(test.serverIP)">-->
<!--                {{ test.serverIP }}-->
<!--              </td>-->
<!--              <td class="cursor-pointer domain text-center" >{{(test.note && test.note !== '') ? test.note: 'N/A'}}</td>-->
<!--              <td class="text-center">-->
<!--                <button @click="bulkAcknowledgeV2(test, user.firstName + ' ' + user.lastName)" :disabled="selectedPlanLoading && selectedPlanLoading === test.planName" v-if="test.showCheckin" type="button" class="btn btn-primary btn-sm">-->
<!--                    <span v-if="selectedPlanLoading && selectedPlanLoading === test.planName">-->
<!--                      <div class="loader mini_loader"></div>-->
<!--                    </span>-->
<!--                  <span v-else>-->
<!--                      Check In-->
<!--                    </span>-->
<!--                </button>-->
<!--              </td>-->
<!--            </tr>-->
<!--            <tr v-else-if="test.tests.length===1">-->
<!--              <td>-->
<!--                <div class="dropdown m-auto">-->
<!--                  <button  style="width: 15px!important; padding: 0!important;" title="Choose Operation" class="settinds-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--                    <i class="fa fa-cog"></i>-->
<!--                  </button>-->
<!--                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">-->
<!--                    <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test.tests[0], 'viewEventsModal')">View Details</a>-->
<!--                    <a class="dropdown-item" href="javascript:void(0)" @click="remove(test.tests[0], test)">Delete</a>-->
<!--                    <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test.tests[0], 'addNoteModal')">Add Notes</a>-->
<!--                    <a class="dropdown-item" href="javascript:void(0)" @click="findUser(test)">Login User</a>-->
<!--                    <a class="dropdown-item" href="javascript:void(0)" @click=" openTicketModal(test.tests[0])">Create Ticket</a>-->
<!--                    <router-link v-if="test.uid " class="dropdown-item" :to="{ name: 'editUser', params: { docID: test.uid || test.tests[0].uid } }">Edit User</router-link>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
<!--              <td class="make-cursor-pointer" @click="doCopy(showDomainName(test.tests[0].url))"> {{showDomainName(test.tests[0].url)}}-->
<!--                <a v-if="getScreenshotUrl(test.tests[0])" :href="getScreenshotUrl(test.tests[0])" target="_blank"><img title="View Screenshot" class="ml-2 w-8" src="../../../../src/assets/img/screenshot.png" alt=""></a>-->
<!--                <a v-if="getResponseUrl(test.tests[0])" :href="getResponseUrl(test.tests[0])" target="_blank"><img title="View Response Url" class="ml-2 w-8" src="../../../../src/assets/img/browser.png" alt=""></a>-->
<!--              </td>-->
<!--              <td class="text-center make-cursor-pointer" @click="doCopy(test.serverIP)">   {{ test.tests[0].serverIP }}</td>-->
<!--              <td class="cursor-pointer domain text-center" >{{(test.tests[0].note && test.tests[0].note !== '') ? test.tests[0].note: 'N/A'}}</td>-->
<!--              <td class="text-center">-->
<!--                <template v-if="test.tests[0].acknowledgedBy">-->
<!--                    <span class="badge badge-pill badge-success">-->
<!--												{{ test.tests[0].acknowledgedBy }}-->
<!--											</span>-->
<!--                </template>-->
<!--                <button @click="acknowledge(test.tests[0])" v-else-if="test.tests[0].status === 'down'" :disabled="selectedMonitorLoading && selectedMonitorLoading === test.tests[0].id" type="button" class="btn btn-primary btn-sm">-->
<!--                    <span v-if="selectedMonitorLoading && selectedMonitorLoading === test.tests[0].id">-->
<!--                      <div class="loader mini_loader"></div>-->
<!--                    </span>-->
<!--                  <span v-else>-->
<!--                      Check In-->
<!--                    </span>-->
<!--                </button>-->
<!--              </td>-->
<!--            </tr>-->
<!--            <tr v-for='(value, index) in test.tests' v-if="test.showTests" :key="index+'test'" class="bg-light">-->
<!--              <td class="">  <div class="dropdown m-auto">-->
<!--                <button  style="width: 15px!important; padding: 0!important;" title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle " type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--                  <i class="fa fa-cog"></i>-->
<!--                </button>-->
<!--                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">-->
<!--                  <a class="dropdown-item" href="javascript:void(0)" @click="openModal(value, 'viewEventsModal')">View Details</a>-->
<!--                  <a class="dropdown-item" href="javascript:void(0)" @click="remove(value, test)">Delete</a>-->
<!--                  <a class="dropdown-item" href="javascript:void(0)" @click="openModal(value, 'addNoteModal')">Add Notes</a>-->
<!--                  <a v-if="test.uid" class="dropdown-item" href="javascript:void(0)" @click="findUser(test)">Login User</a>-->
<!--                  <a v-if="test.uid" class="dropdown-item" href="javascript:void(0)" @click="openTicketModal(value)">Create Ticket</a>-->
<!--                  <router-link v-if="value.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: test.uid || value.uid } }">Edit User</router-link>-->
<!--                </div>-->
<!--              </div></td>-->
<!--              <td class="make-cursor-pointer" @click="doCopy(showDomainName(value.url))">-->
<!--                {{ showDomainName(value.url) }}-->
<!--                <a v-if="getScreenshotUrl(value)" :href="getScreenshotUrl(value)" target="_blank"><img class="ml-2 w-8"  title="View Screenshot"  src="../../../../src/assets/img/screenshot.png" alt=""></a>-->
<!--                <a v-if=" getResponseUrl(value)" :href="getResponseUrl(value)" target="_blank"> <img  class="ml-2 w-8" title="View Response Url"   src="../../../../src/assets/img/browser.png" alt=""></a>-->
<!--              </td>-->
<!--              <td class="text-center make-cursor-pointer" @click="doCopy(value.serverIP)">{{ value.serverIP }}</td>-->
<!--              <td class="cursor-pointer domain text-center" >{{(value.note && value.note !== '') ? value.note: 'N/A'}}</td>-->
<!--              <td class="text-center">-->
<!--                <span class="badge badge-pill badge-danger">-->
<!--                  Pending-->
<!--                </span>-->
<!--&lt;!&ndash;                <template>&ndash;&gt;-->
<!--&lt;!&ndash;                    <span v-if="value.acknowledgedBy" class="badge badge-pill badge-success">&ndash;&gt;-->
<!--&lt;!&ndash;												{{value.acknowledgedBy}}&ndash;&gt;-->
<!--&lt;!&ndash;                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                  <template v-else-if="test.status === 'down'">&ndash;&gt;-->
<!--&lt;!&ndash;                    <button @click="acknowledge(value)" v-if="value.downCount === 1" :disabled="selectedMonitorLoading && selectedMonitorLoading === value.id" type="button" class="btn btn-primary btn-sm">&ndash;&gt;-->
<!--&lt;!&ndash;                        <span v-if="selectedMonitorLoading && selectedMonitorLoading === value.id">&ndash;&gt;-->
<!--&lt;!&ndash;                          <div class="loader mini_loader"></div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </span>&ndash;&gt;-->
<!--&lt;!&ndash;                      <span v-else>&ndash;&gt;-->
<!--&lt;!&ndash;                          Check In&ndash;&gt;-->
<!--&lt;!&ndash;                        </span>&ndash;&gt;-->
<!--&lt;!&ndash;                    </button>&ndash;&gt;-->
<!--&lt;!&ndash;                    <span v-else class="badge badge-pill badge-danger">&ndash;&gt;-->
<!--&lt;!&ndash;												Pending&ndash;&gt;-->
<!--&lt;!&ndash;                      </span>&ndash;&gt;-->
<!--&lt;!&ndash;                  </template>&ndash;&gt;-->
<!--&lt;!&ndash;                </template>&ndash;&gt;-->
<!--              </td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--          </table>-->
<!--        </perfect-scrollbar >-->
<!--        <div v-if="testGroups && testGroups.length === 0 && !loading">  <p class="hm300 card-text text-center text-danger mb-3 font-weight-bold">No data found.</p></div>-->
      </div>
    </div>
    <ticket-modal ref="ticketModal"/>
    <div class="modal_body" >
      <div class="modal" tabindex="-1" role="dialog" id="viewEventsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                Test ID: <code>{{selectedItemForView.id}}</code>
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Test Name:
                <code>{{selectedItemForView.name }}</code>
              </h6>
              <br>
              <code>
                <table class="table eventsTable">
                  <thead>
                  <tr>
                    <th class="text-center">Start</th>
                    <th class="text-center">End</th>
                    <th class="text-center">Time Duration</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Acknowledged By</th>
                    <!--                    <th class="text-center">Status Code</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(event, index) in selectedItemForView.incidents" :key="'event_' + index">
                    <td class="text-center">{{event.start | formatDate}}</td>
                    <td class="text-center" v-if="event.end">{{event.end | formatDate}}</td>
                    <td class="text-center" v-else>Current</td>
                    <td class="text-center" v-if="event.end !== undefined">{{timeDifferenceBetweenGivenDates(event.end, event.start)}}</td>
                    <td class="text-center" v-else>-</td>
                    <td class="text-center">{{event.status}}</td>
                    <td class="text-center">{{event.acknowledgedBy || ''}}</td>
                    <!--                    <td class="text-center">{{event.status=='up' ? 200 : 500}}</td>-->
                  </tr>
                  </tbody>
                </table>
              </code>
              <section v-if="selectedItemForView.notes !== undefined">
                <h6>Test & Notes History</h6>
                <code>
                  <table class="table notesTable">
                    <thead>
                    <tr>
                      <th class="text-center">Detail</th>
                      <th class="text-center">Added On</th>
                      <th class="text-center">Added By</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(note, index) in selectedItemForView.notes" :key="'note_' + index">
                      <td>{{note.note}}</td>
                      <td class="text-center">{{note.noteDate | formatDate}}</td>
                      <td class="text-center">{{note.noteAddedBy ? note.noteAddedBy : ''}}</td>
                    </tr>
                    </tbody>
                  </table>
                </code>
              </section>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" tabindex="-1" role="dialog" id="addNoteModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Test Name: {{selectedItemForView.name}}</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Add note</label>
                <textarea class="form-control" v-model="selectedItemForView.note"></textarea>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              <button class="btn btn-outline-info btn-sm" :disabled="action"  @click="addNote()">
                <div class="loader mini_loader" v-if="selectedItemForView && action === 'addNote'"></div>
                Add Note
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import {db} from "@/firebase/init";
import _ from "lodash";
import swal from "sweetalert2";
import statisticsMixin from "@/mixins/statisticsMixin";
import ticketModal from "@/components/Admin/EditUser/HostingDetailsUpdate/ticketModal.vue";
import AdminLogs from "@/mixins/adminLogs";
import moment from "moment/moment";
import dateMixin from '../../../mixins/dateMixin'
import loginAsMixin from "../../../mixins/loginAsMixin";
import md5 from "crypto-js/md5";

export default {
  name: "Monitors",
  mounted(){
    this.loadOutages();
    this.getPresetReplies();
  },
  mixins: [statisticsMixin, AdminLogs,dateMixin,loginAsMixin],
  components: {
    PerfectScrollbar, ticketModal
  },
  beforeDestroy(){
    this.monitorListener();
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    allGroups(){
      const checkedInGroups = this.testGroups.filter(el => !el.showCheckin);
      let pendingGroups = this.testGroups.filter(el => el.showCheckin);
      pendingGroups = pendingGroups.slice(0,10);
      return [...pendingGroups, ...checkedInGroups]
    }
  },
  methods: {
    getResponseUrl (test) {
      return test.incidents[test.incidents.length - 1].responseUrl || '';
    },
    getScreenshotUrl (test) {
      return test.incidents[test.incidents.length - 1].screenshotUrl;
    },
    doCopy(item){
      this.$copyText(item).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      }, function (e) {
        console.log(e)
      });
    },
    addNote(){
      this.action = 'addNote';
      console.log('Adding note in: ' + this.selectedItemForView.id);
      if(this.selectedItemForView.notes === undefined){
        this.selectedItemForView.notes = [];
      }
      this.selectedItemForView.noteAddedBy= this.user.firstName + ' ' + this.user.lastName
      this.selectedItemForView.noteAddedAt= new Date().toISOString()
      this.selectedItemForView.notes.push({
        noteDate: new Date().toISOString(),
        note: this.selectedItemForView.note,
        noteAddedBy: this.user.firstName + ' ' + this.user.lastName
      });
      db.collection('monitors').doc(this.selectedItemForView.id.toString())
          .update(this.selectedItemForView)
          .then(()=>{
            /* eslint-disable */
            $("#addNoteModal").modal("hide");
            /* eslint-enable */
            swal('Success', 'Note has been successfully added', 'success');
          }).catch(() => {
        swal('Error', 'Error in adding note!', 'error');
      }).finally(() => {
        this.selectedItemForView = {};
        this.action = null
      });
    },
    findUser(group){
      if (group.uid ) {
        // let customers = localStorage.getItem('customers') ? JSON.parse(localStorage.getItem('customers')) : [];
        // let user = find(customers, {'docID': uid});
        swal({
          title: group.firstName + ' ' + group.lastName,
          text: 'Would you like to login to this customer\'s WPO account',
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then( result => {
          if(result.value){
            this.goToNuxt(group.uid);
          }
        });
      } else {
        swal("Not Found!", 'Plan is not found in the WPO', 'error');
      }
    },
    remove(test, group) {
      swal({
        title: "Are you sure?",
        text: `Are you sure you want to delete this test?`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
          .then(async result => {
            if (result.value){
              this.removeItem = test;
              this.action = 'remove';
              try{
                await this.$http.post("monitor/delete/test", {
                  grant_type: "token",
                  token: this.userToken,
                  testId: test.id
                })
              }catch (err){
                console.log(err.toString())
              }
              try{
                await db.collection('monitors').doc(test.id.toString()).delete();
                // await this.removeAdminActiveTask({taskId:test.id})
                await this.startGrouping();
                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Monitor test has been deleted, TestId: ${test.id}, Test Name: ${test.name}`,
                  level: "info"
                })
                if (group) {
                  group.tests = group.tests.filter(t=> t.id !== test.id)
                }
              }catch(err){
                let responseMessage = err.response.data.message;
                if (err.response.status === 422) {
                  responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
                } else if (err.response.status === 401) {
                  responseMessage = "You need update token. Please Try Again!";
                  this.refreshToken();
                }
                swal({
                  title: "Something went wrong!",
                  html: responseMessage,
                  type: "error",
                  confirmButtonText: "Try Again!",
                  confirmButtonColor: "#EE8057"
                });
                this.addLog({
                  name: this.user.firstName + " " + this.user.lastName,
                  message: "Error delete monitor test. Message: " + responseMessage,
                  level: "danger"
                });
              } finally{
                this.action = null;
                this.removeItem = null;
              }
            }
          });
    },
    openModal(test, el){
      if(el === 'viewEventsModal'){
        this.selectedItemForView = JSON.parse(JSON.stringify(test));
        this.selectedItemForView.incidents.reverse();
        if(this.selectedItemForView.notes !== undefined){
          this.selectedItemForView.notes.reverse();
        }
        let durations = [];
        for(let event of this.selectedItemForView.incidents){
          if(event.status === 'down' && event.end !== undefined){
            let dur = this.timeDifferenceBetweenGivenDates(event.end, event.start);
            if(dur.split(':').length === 2){
              durations.push("00:" + dur);
            }else if(dur.split(':').length === 1){
              durations.push("00:00:" + dur);
            }else{
              durations.push(dur);
            }
          }
        }
        const totalDurations = moment.duration();
        durations.map(duration => {
          totalDurations.add(duration);
        });
        this.totalDownDurationOfSelectedItem = moment.utc(totalDurations.asMilliseconds()).format("HH:mm:ss");
      }else{
        this.selectedItemForView =  JSON.parse(JSON.stringify(test));
      }

      /* eslint-disable */
      $("#" + el).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
      /* eslint-enable */
    },
    async acknowledge(test, acknowledgedBy, noTicket) {
      // const incidents = JSON.parse(JSON.stringify(test.incidents))
      // const obj = incidents.reverse().find(inc => !!inc.id);
      let incidentId= test.incidents[test.incidents.length-1].id || ''
      const acknowledgedByName= acknowledgedBy ? acknowledgedBy : !noTicket ? this.user.firstName + ' ' + this.user.lastName : ''
      try{
        this.selectedMonitorLoading= test.id
        // save acknowledged by in db
        if (acknowledgedByName) {
          test.incidents[test.incidents.length - 1].acknowledgedBy = acknowledgedByName;
          test.incidents[test.incidents.length - 1].acknowledgedAdminEmail = this.user.email;
          await db.collection('monitors').doc(test.id).update({
            incidents: test.incidents
          })
        }
        if(incidentId && acknowledgedByName && !noTicket){
          // await this.$http.post("monitor/acknowledge/incident", {
          //   grant_type: "token",
          //   token: this.userToken,
          //   incidentId: incidentId,
          //   acknowledgedBy: acknowledgedByName
          // })
          if(!noTicket) {
            try{
              await this.incrementCountBasedOnType(this.user, 'monitor')
              try {
                const data= {
                  ticketId: test.id,
                  taskId:  test.id,
                  type  : 'info',
                  message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${this.showDomainName(test.url)}.`,
                  actionType: 'monitor',
                  customer: {
                    domain: this.showDomainName(test.url),
                  }
                }
                // await this.addToAdminActiveTask({...data})
                await this.addRecentActivity({...data})
              } catch (e) {
                console.log('unable to save recent activity', e.toString())
              }

            }catch (e) {
              console.log('line 1063', e.toString())
            }
          }
        }
        if (acknowledgedByName) {
          await this.saveInDBAndShowSuccess(test, acknowledgedByName, noTicket)
        }
        this.$http.post('/utilities/update-availability-status', {
          grant_type: "token",
          event: 'monitor_in',
        })


      }catch (err){
        console.log('this error', err.toString())
        let errorMessage = 'Something went wrong while acknowledging the monitor';
        if (!err || !err.response || err.response.status !== 409 ) {
          test.incidents[test.incidents.length -1].acknowledgedBy = ''
          await db.collection('monitors').doc(test.id).update({ incidents: test.incidents})
          if(!noTicket) {
            swal({
              title: "Error!",
              text: errorMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
          }
        }

      } finally {
        this.selectedMonitorLoading= null
      }

    },
    async bulkAcknowledgeV2(group, acknowledgedBy, noIncrement=null){
      try{
        const encryptedEmail =  this.user.email ?  md5(this.user.email.trim().toLowerCase()).toString() : '';
        const result  = await this.$http.post('/monitor/bulk-acknowledge',{
          grant_type: 'token',
          group,
          acknowledgedBy,
          noIncrement, encryptedEmail
        });
        swal({
          title: 'Success!',
          text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
          type: 'success',
          showCancelButton: true,
          confirmButtonColor: "#6ACF98",
          cancelButtonColor: "#EE8057",
          confirmButtonText: "Yes Proceed",
          cancelButtonText: "No Thanks",
        }).then((result) => {
          if(result.value) {
            this.openTicketModal(group.tests[0], 'checkin')
          }
        })
      }
      catch(e) {
        console.log('Error Occurred', e.toString())
      }
    },
    async bulkAcknowledge( group, acknowledgedBy, noIncrement){
      console.log('Bulk Acknowledged was called')
      try {
        const firstCheckin = !group.tests.find(el => {
          return el.incidents[el.incidents.length - 1].acknowledgedBy
        });
        this.selectedPlanLoading= group.planName
        for(const row of group.tests){
          const lastObj = row.incidents[row.incidents.length - 1]
          if(!lastObj.acknowledgedBy && lastObj.status === 'down'){
            console.log('monitor to be processed', row.id)
            await this.acknowledge(row, acknowledgedBy, true)
          }
        }
        if (!noIncrement) {
          try{
            const data= {
              ticketId: group.uid,
              taskId:  group.uid,
              type  : 'info',
              message: `${this.user.firstName} ${this.user.lastName} has checked in Monitor ${group.uid}.`,
              actionType: 'monitor',
              customer: {
                domain: group.uid,
              }
            }
            // await this.addToAdminActiveTask({...data})
            await this.addRecentActivity({...data})
            await this.incrementCountBasedOnType(this.user, 'monitor')
          }catch (e) {
            console.log('line 1016', e.toString())
          }
        }
        if(firstCheckin){
          console.log('firstCheckin')
          swal({
            title: 'Success!',
            text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
            type: 'success',
            showCancelButton: true,
            confirmButtonColor: "#6ACF98",
            cancelButtonColor: "#EE8057",
            confirmButtonText: "Yes Proceed",
            cancelButtonText: "No Thanks",
          }).then((result) => {
            if(result.value) {
              this.openTicketModal(group.tests[0], 'checkin')
            }
          })
        }
        this.selectedPlanLoading= null
      }catch (e) {
        this.selectedPlanLoading= null
        console.log('error while acknowledging', e.toString())
      }
    },
    async saveInDBAndShowSuccess(test, ack_by, noTicket) {
      this.selectedMonitorLoading= null
      if(!noTicket){
        swal({
          title: 'Success!',
          text: 'You have successfully acknowledged the monitor. Would you like to create a ticket for this monitor?',
          type: 'success',
          showCancelButton: true,
          confirmButtonColor: "#6ACF98",
          cancelButtonColor: "#EE8057",
          confirmButtonText: "Yes Proceed",
          cancelButtonText: "No Thanks",
        }).then((result) => {
          if(result.value) {
            this.openTicketModal(test, 'checkin')
          }
        })
      }
    },
    async openTicketModal(group, from){
      await this.$refs.ticketModal.load(this.presetMacros, group, from)
    },
    async getPresetReplies(){
      this.presetMacros=[]
      let result=await db.collection("permissions")
          .doc("preset_macros_outages")
          .get();
      if(result.exists){
        this.presetMacros = result.data().replies;
      }
    },
    loadOutages () {
      this.loading = false;
      let upQuery = null;
        this.testDown = [];
        upQuery = db.collection('monitors')
            .where('status', '==', 'down')
            .limit(500);
        this.monitorListener = upQuery.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            switch (change.type) {
              case 'added':{
                const test= {id: change.doc.id , ...change.doc.data()}
                this.testDown.push(test);
                break;}
              case "modified":
              {
                const modifiedData = change.doc.data();
                let tIndex = this.testDown.findIndex(test => test.id === change.doc.id);
                this.testDown[tIndex] = { id: change.doc.id , ...modifiedData}
              }
                break;
              case "removed":
              {
                const removedData = change.doc.data();
                this.testDown = this.testDown.filter(test => test.id !== removedData.id);
              }
                break;
            }
          });
          this.startGrouping()

        });
      this.loading = true;
      console.log('groups', this.testGroups)
    },
    getAcknowledgeBy (test) {
      if (test.incidents && test.incidents.length) {
        return test.incidents[test.incidents.length-1].acknowledgedBy || ''
      }
      return false
    },
    getTotalOutages(group){
      return group.tests.reduce((a, b) => a + (b.downCount || 0), 0);
    },
    showDomainName (url) {
      const domainName = url.replace('https://', '').replace('/?v={timestamp}', '');
      return domainName
    },
    startGrouping () {
      this.testGroups= []
      this.adminTestGroups=[]
      const testIps = ['69.162.173.212', '23.29.145.209']
      this.testDown = this.testDown.filter(test => {
        return !testIps.includes(test.serverIP)
      })
      let testGroups=this.testGroups;
      this.testDown.map(test => {
        const planName = test.plan || 'Not in WPO';
        test.acknowledgedBy = this.getAcknowledgeBy(test);
        let group= null;
        if(!test.acknowledgedBy || (test.acknowledgedBy && test.acknowledgedBy === `${this.user.firstName} ${this.user.lastName}`)){
          group = testGroups.find(g => g.planName && g.planName === planName);
        }
          console.log('acknowledged by results', test.acknowledgedBy)
          test.showCause = false
          if (!group && !test.acknowledgedBy || (test.acknowledgedBy && test.acknowledgedBy === `${this.user.firstName} ${this.user.lastName}`)) {
            group = {
              notInWPO: test.plan ? false : true,
              planName: planName,
              serverIP: test.serverIP || '',
              uid: test.uid,
              firstName: test.firstName,
              lastName: test.lastName,
              tests: [test],
              showTests: this.openedGroups.includes(planName),
            };
            console.log('pushing')
            testGroups.push(group);
          } else if (group) {
            const testExist = group.tests.find(t => (t.id === test.id));
            if (!testExist) {
              group.tests.push(test);
              if (test.status === 'down') {
                group.downCount += 1;
              } else if (test.status === 'paused') {
                group.pauseCount += 1;
              } else if (test.status === 'pending') {
                group.pendingCount += 1;
              }
            } else if (testExist && testExist.status !== test.status) {
              testExist.status = test.status;
              if (test.status === 'down') {
                group.pauseCount -= 1;
                group.downCount += 1;
              } else if (testExist.status === 'paused') {
                group.pauseCount += 1;
                group.downCount -= 1;
              }
            }
          }
      });
      testGroups.map(g => {
        if(g.tests.length === 1 && !g.tests[0].acknowledgedBy) {
          g.showCheckin = true
        }else{
          g.acknowledgedByNames = [];
          g.showCheckin = false;
          g.tests.map(el => {
            if (!el.acknowledgedBy) {
              g.showCheckin = true
            }
          })
          console.log('show checkin', g.showCheckin)
          // if (g.showCheckin) {
          //   // check if any down monitor and checked in
          //   const obj = g.tests.find(el => {
          //     const isAcknowledged = el.incidents[el.incidents.length - 1].acknowledgedBy;
          //     return el.status === 'down' && isAcknowledged
          //   })
          //   if (obj) {
          //     g.showCheckin = false;
          //   }
          //   // bring down monitors on top
          //   g.tests = g.tests.sort((a, b) =>
          //       a.status.localeCompare(b.status));
          // }
          g.downCounts= this.getTotalOutages(g)
          if (g.downCount === 1 && (g.planName !=='(N/A)' && g.planName !== 'Suspended') ) {
            // if downCount is 1 then expand the plan
            this.openedGroups.push(g.planName)
            g.showTests = this.openedGroups.includes(g.planName)
          }
        }
        g.status=g.tests.find(el => el.status==='down') ? 'down' : 'paused'

      });
      this.loading = false
      console.log('groups', this.testGroups, this.adminTestGroups)
    }
  },
  data () {
    return {
      autoLoading: false,
      loading: false,
      selectedFilter: { key: 'myTickets'},
      perpage: 20,
      recentTicketCommentList: [],
      testDown: [],
      monitorListener: null,
      testGroups: [],
      adminTestGroups: [],
      openedGroups: [],
      selectedPlanLoading : null,
      selectedMonitorLoading: null,
      selectedItemForView: {},
      totalDownDurationOfSelectedItem: '',
      presetMacros: [],
      action: null,
      removeItem : null,
    }
  }
}
</script>
<style scoped>
.scroll-area {
  position: relative;
  height: 340px;
  /*overflow: hidden;*/
}
.scroll-area-modal {
  position: relative;
  max-height: 340px;
  min-height: 230px;
  overflow: hidden;
}
td{
  padding:  7px 7px !important;
}
.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
}

.details-control.shown {
  width: 20px !important;
  height: 20px;
  background: url('../../../assets/img/details_close.png') no-repeat center center;
  display: block;
}
.bg-light {
  background-color: rgba(251,198, 88, 0.1) !important;
}
th{
  font-weight: bold !important;
}
.dropdown-toggle:after {
  display: none;
}
.w-8 {
  width: 4% !important;
  height: 4% !important;
}
.settinds-btn, .settinds-btn:active, .settinds-btn:focus {
  margin-left: 2px;
  background-color: transparent!important;
  color: black!important;
}
.settinds-btn:hover {
  background-color: black!important;
  color: white !important;
}
.table-responsive{
  padding-bottom: 50px !important;
}
</style>
